// extracted by mini-css-extract-plugin
export default {"container":"container__21b17a88","icon":"icon__21b17a88"};